import axios from '@/plugins/axios'

export default {
  login(email, password) {
    return axios.post('auth/login', {
      email: email,
      password: password
    }).then(response => {
      return response.data
    })
  },
  logout() {
    return axios.post('auth/logout')
  },
  me() {
    return axios.get('auth/me').then(response => {
      return response.data
    })
  }
}
